import { render, staticRenderFns } from "./VideoBox.vue?vue&type=template&id=3bbc63b2&scoped=true&"
import script from "./VideoBox.vue?vue&type=script&lang=ts&"
export * from "./VideoBox.vue?vue&type=script&lang=ts&"
import style0 from "./VideoBox.vue?vue&type=style&index=0&id=3bbc63b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbc63b2",
  null
  
)

export default component.exports